import { RefObject } from 'react';

import { AccessibilityInfo, findNodeHandle } from 'react-native';

import { isWeb } from 'utils/responsiveness';

function setAccessibilityFocusTo(ref: RefObject<any>) {
    if (ref.current) {
        if (isWeb) {
            setTimeout(() => ref.current?.focus(), 300);
        } else {
            const reactTag = findNodeHandle(ref.current);

            if (reactTag) {
                if (isWeb) {
                    setTimeout(
                        () =>
                            ref.current?.focus({
                                preventScroll: true,
                                focusVisible: true,
                            }),
                        300,
                    );
                } else {
                    AccessibilityInfo.setAccessibilityFocus(reactTag);
                }
            }
        }
    }
}

export default setAccessibilityFocusTo;
